<template>
  <div class="search-step-info" :class="{ desktop: $isDesktop }">
    <div v-if="noDates">
      <translate>Choose your dates</translate>
    </div>
    <div v-else class="dates-summary">
      <div class="dates-summary-date">
        <translate class="title"> Arrive </translate>
        <br />
        <span v-if="start">
          <pu-utc-date
            :date="start"
            :options="{ weekday: 'short', day: 'numeric', month: 'short' }"
          />
          <pu-utc-date tag="span" class="year" :date="start" options="year" />
        </span>
      </div>
      <span class="nights">
        <i>{{ nights }}</i>
        <translate class="title" :tt="{ numberOfNights: nights }"
          >{nights, plural, one{Night} other{Nights}}</translate
        >
      </span>
      <div class="dates-summary-date">
        <translate class="title"> Depart </translate>
        <br />
        <span v-if="end">
          <pu-utc-date
            :date="end"
            :options="{ weekday: 'short', day: 'numeric', month: 'short' }"
          />
          <pu-date tag="span" class="year" :date="end" options="year" />
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { daysBetween } from '~/utility/date/relative'

@Component
class DatesWizardBodyHeaderRange extends Vue {
  @Prop({ required: true })
  start: string | null

  @Prop({ required: true })
  end: string | null

  get noDates(): boolean {
    return !this.start && !this.end
  }

  get nights(): number {
    if (!this.start || !this.end) {
      return 0
    }
    return daysBetween(this.start, this.end)
  }
}

export default toNative(DatesWizardBodyHeaderRange)
</script>
<style scoped>
.dates-summary {
  width: 100%;
  align-items: center;
  display: flex;
  justify-content: space-evenly;
}

.dates-summary-date {
  flex-basis: 100%;
}

.search-step-info {
  align-items: center;
  background-color: var(--colour-pale-blue);
  color: var(--colour-dark-blue);
  display: flex;
  justify-content: center;
  margin: calc(-4vw - 0.25em);
  margin-bottom: 0;
  min-height: 5.5em;
  padding: 0.75em;
  text-align: center;
}

.nights {
  align-items: center;
  color: white;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 1em;
  min-height: 4em;
  min-width: 4em;
  position: relative;
  text-align: center;
  z-index: 2;
}

.nights:after {
  background-color: var(--colour-dark-blue);
  border-radius: 50%;
  content: '';
  display: block;
  height: 0;
  padding-bottom: 100%;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: -1;
}

.nights i {
  font-weight: bold;
  font-style: normal;
  font-size: 1.35em;
}

time {
  font-weight: bold;
}

.title {
  font-weight: normal;
}

.nights .title {
  font-size: var(--body);
}
/* desktop & tablet */
.search-step-info.desktop {
  margin: -2em -2em 0 -2em;
}
</style>
